import { render, staticRenderFns } from "./CardCheckFic.vue?vue&type=template&id=5b809a12&"
import script from "./CardCheckFic.vue?vue&type=script&lang=js&"
export * from "./CardCheckFic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports